<template>
    <nav v-if="items" class="flex flex-row">
        <a
            v-for="item in items" :key="`nav_cat_item_${item.id}`"
            class="inline-block ml-1"
            :class="[item.active ? 'bg-grey-100' : 'bg-black bg-opacity-30 hover:bg-opacity-60']"
            :href="item.url"
            :content="item.name" v-tippy="{ placement: 'bottom', size: 'large', arrow: true }"
        >
             <span class="sr-only">{{ item.name }}</span>
            <img width="65" :src="getImage(item)" />
        </a>
    </nav>
</template>

<script>
export default {
    props: ['categories', 'activeCategory'],
    data() {
        const items = this.categories.map(cat => {
            return {
                ...cat,
                active: cat.id === this.activeCategory
            };
        });

        return {
            items
        };
    },
    methods: {
        getImage(item) {
            return item.active ? item.bildeValgt : item.bildeIkkeValgt;
        }
    }
};
</script>
